<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <h4>参加予定の大会</h4>
      <span v-if="items.size==0" class="subheading orange--text">
        <hr class="divider my-5">
        大会にエントリーしてください。
        <hr class="divider my-5">
      </span>
    </v-flex>
  </v-layout>

 <v-layout>
    <v-flex xs12 sm6 offset-sm3>
        <v-list two-line>
          <template v-for="item in items">

            <v-card :to="item.to" class="mb-3">
                <v-card-media
                  class="white--text"
                  v-bind:class="'colorfilter-' + item.category"
                  height="200px"
                  src="/static/carousel/1.JPG"
                >
                  <v-container fill-height fluid>
                    <v-layout fill-height>
                      <v-flex xs12 align-center flexbox>
                        <div class="ah-tournament-card">
                          <span class="sub-title">{{item.startTime | dateformat}}</span>
                          <span class="title">{{item.title}}</span>
                          <span class="sub-title">{{item.subTitle}}</span>
                        </div>

                        <span class="display-1">
                          </span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-media>
            </v-card>
          </template>
        </v-list>
    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
import firebase from 'firebase'
export default {
  data () {
    return {
      items: []
    }
  },
  created () {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        // location.href = '/#/auth?' + this.$route.params.id
      } else {
        // サインイン済み
        this.init()
      }
    })
  },
  methods: {
    init: function () {
      var db = firebase.firestore()

      let user = firebase.auth().currentUser
      let query = db.collection('m2m_teams_users').where('user', '==', user.uid)
      query.get().then(querySnapshot => {
        querySnapshot.forEach(documentSnapshot => {
          let obj = documentSnapshot.data()

          db.collection('entries').where('team', '==', obj.team).get().then(querySnapshot => {
            querySnapshot.forEach(doc => {
              var obj = doc.data()
              var docRef = db.collection('tournaments').doc(obj.tournament)
              // Read the document.
              docRef.get().then(doc => {
                if (doc.exists) {
                  var obj = doc.data()
                  if (obj.endTime > new Date()) {
                    obj.to = '/tournament/' + doc.id
                    this.items.push(obj)
                  }
                } else {
                  console.log('No such document!')
                }
              }).catch(function (error) {
                console.log('Error getting document:', error)
              })
            })
          })
        })
      })
    },
    tournaments: function () {
      var db = firebase.firestore()
      db.collection('tournaments').get()
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/schedule/Index.vue